export default __webpack_public_path__ + "static/media/logo.785b2e1b.jpg";